<template>
  <div class="container">
    <!-- Top Alert Messages -->
    <v-alert
      v-if="successMessage"
      type="success"
      dismissible
      @input="successMessage = null"
      class="mb-4"
    >
      {{ successMessage }}
    </v-alert>

    <v-alert
      v-if="errorMessage"
      type="error"
      dismissible
      @input="errorMessage = null"
      class="mb-4"
    >
      {{ errorMessage }}
    </v-alert>

    <!-- Provider & Summary Cards -->
    <v-row class="mb-2">
      <v-col cols="12" md="4">
        <v-card outlined class="pa-3 d-flex align-center">
          <v-avatar color="primary" class="mr-3" size="44">
            <v-icon dark>mdi-cloud-sync</v-icon>
          </v-avatar>
          <div>
            <div class="text-caption grey--text">Κανάλι Διαβίβασης</div>
            <div class="text-subtitle-1 font-weight-bold" v-if="provider === 'primer'">
              <v-chip small color="blue darken-1" dark>
                <v-icon left x-small>mdi-check-circle</v-icon>
                Primer Connector
              </v-chip>
            </div>
            <div class="text-subtitle-1 font-weight-bold" v-else-if="provider === 'mydata'">
              <v-chip small color="teal darken-1" dark>
                <v-icon left x-small>mdi-check-circle</v-icon>
                myDATA (ΑΑΔΕ Direct)
              </v-chip>
            </div>
            <div class="text-subtitle-1 font-weight-bold" v-else>
              <v-chip small color="red" dark>
                <v-icon left x-small>mdi-alert-circle</v-icon>
                Μη ρυθμισμένο
              </v-chip>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-card outlined class="pa-3 d-flex align-center">
          <v-avatar color="orange darken-1" class="mr-3" size="44">
            <v-icon dark>mdi-file-clock</v-icon>
          </v-avatar>
          <div>
            <div class="text-caption grey--text">Εκκρεμή Παραστατικά</div>
            <div class="text-h6 font-weight-bold">{{ items.length }}</div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-card outlined class="pa-3 d-flex align-center">
          <v-avatar color="green darken-1" class="mr-3" size="44">
            <v-icon dark>mdi-cash-multiple</v-icon>
          </v-avatar>
          <div>
            <div class="text-caption grey--text">Συνολική Αξία Εκκρεμών</div>
            <div class="text-h6 font-weight-bold">{{ formatCurrency(totalGrossSum) }}</div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Filters Expansion Panel -->
    <v-expansion-panels class="mb-4" v-model="panelOpen">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left small>mdi-filter-variant</v-icon>
            Φίλτρα αναζήτησης
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDateStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="documentIssueDateStartFilter"
                    label="Ημερομηνία έκδοσης (Από)"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="documentIssueDateStartFilter"
                  @input="menuDateStart = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDateStop"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="documentIssueDateStopFilter"
                    label="Ημερομηνία έκδοσης (Έως)"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="documentIssueDateStopFilter"
                  @input="menuDateStop = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-select
                v-model="documentKindFilter"
                :items="documentKindOptions"
                label="Κατηγορία Παραστατικού"
                dense
                outlined
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="searchQuery"
                label="Αναζήτηση (Τίτλος, Πελάτης, ΑΦΜ)"
                append-icon="mdi-magnify"
                clearable
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

                    <v-row class="my-3" align="center" justify="center">
            <v-btn
              color="success"
              rounded
              elevation="2"
              class="mx-2 px-5 font-weight-bold white--text"
              @click="getData"
              :loading="loading"
            >
              <v-icon left size="20">mdi-magnify</v-icon>
              <span>ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn
              color="orange darken-2"
              dark
              rounded
              elevation="2"
              class="mx-2 px-5 font-weight-bold white--text"
              @click="clearFilters"
              :disabled="loading"
            >
              <v-icon left size="20">mdi-broom</v-icon>
              <span>ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Main Data Table -->
    <v-card class="elevation-1">
      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :loading="loading"
        :search="searchQuery"
        :sort-by="['issue_date', 'id']"
        :sort-desc="[true, true]"
        multi-sort
        class="elevation-0"
        no-data-text="Δεν υπάρχουν εκκρεμή παραστατικά προς διαβίβαση!"
        loading-text="Φόρτωση εκκρεμών παραστατικών..."
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title class="font-weight-bold">
              <v-icon left color="primary">mdi-cloud-upload-outline</v-icon>
              Εκκρεμή Παραστατικά myDATA
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <div class="text-subtitle-2 grey--text text--darken-2">
              {{ filteredItems.length }} εγγραφές | Σύνολο: {{ formatCurrency(totalGrossSum) }}
            </div>
            <v-spacer></v-spacer>

            <v-btn
              color="success"
              dark
              class="mr-2"
              @click="transmitAll"
              :disabled="items.length === 0 || isBatchTransmitting"
              :loading="isBatchTransmitting"
            >
              <v-icon left>mdi-cloud-upload-multiple</v-icon>
              ΑΠΟΣΤΟΛΗ ΟΛΩΝ
            </v-btn>

            <v-btn
              icon
              color="primary"
              @click="getData"
              :disabled="loading || isBatchTransmitting"
              title="Ανανέωση"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
        </template>

        <!-- Issue Date Column -->
        <template v-slot:[`item.issue_date`]="{ item }">
          {{ formatDate(item.issue_date) }}
        </template>

        <!-- Kind Badge Column -->
        <template v-slot:[`item.document_kind_label`]="{ item }">
          <v-chip
            x-small
            :color="getKindColor(item.document_kind)"
            dark
            class="font-weight-bold"
          >
            <v-icon left x-small>{{ getKindIcon(item.document_kind) }}</v-icon>
            {{ item.document_kind_label }}
          </v-chip>
        </template>

        <!-- Document Title / Number -->
        <template v-slot:[`item.formatted_title`]="{ item }">
          <span class="font-weight-medium">{{ item.formatted_title }}</span>
          <div class="text-caption grey--text">{{ item.type_description }}</div>
        </template>

        <!-- Counterpart Column -->
        <template v-slot:[`item.counterpart_name`]="{ item }">
          <div class="font-weight-medium text-truncate" style="max-width: 220px;" :title="item.counterpart_name">
            {{ item.counterpart_name }}
          </div>
          <div class="text-caption grey--text">
            ΑΦΜ: {{ item.counterpart_afm || '-' }}
          </div>
        </template>

        <!-- Net Value Column -->
        <template v-slot:[`item.net_value`]="{ item }">
          <span class="text-right d-block">{{ formatCurrency(item.net_value) }}</span>
        </template>

        <!-- Tax Value Column -->
        <template v-slot:[`item.tax_value`]="{ item }">
          <span class="text-right d-block">{{ formatCurrency(item.tax_value) }}</span>
        </template>

        <!-- Gross Value Column -->
        <template v-slot:[`item.gross_value`]="{ item }">
          <span class="font-weight-bold text-right d-block">{{ formatCurrency(item.gross_value) }}</span>
        </template>

        <!-- Status / Error Column -->
        <template v-slot:[`item.status`]="{ item }">
          <div v-if="item.last_error">
            <v-tooltip bottom max-width="350">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  x-small
                  color="error"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="openErrorDialog(item)"
                  style="cursor: pointer;"
                >
                  <v-icon left x-small>mdi-alert-circle</v-icon>
                  Σφάλμα
                </v-chip>
              </template>
              <span>{{ item.last_error }} (Κάντε κλικ για λεπτομέρειες)</span>
            </v-tooltip>
          </div>
          <div v-else>
            <v-chip x-small color="warning" dark>
              <v-icon left x-small>mdi-clock-outline</v-icon>
              Εκκρεμεί
            </v-chip>
          </div>
        </template>

        <!-- Actions Column -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            small
            color="primary"
            class="px-2"
            @click="transmitSingle(item)"
            :loading="transmittingKey === `${item.document_kind}-${item.id}`"
            :disabled="isBatchTransmitting"
          >
            <v-icon left small>mdi-cloud-upload</v-icon>
            Αποστολή
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Error Detail Dialog -->
    <v-dialog v-model="errorDialog" max-width="550px">
      <v-card>
        <v-card-title class="text-h6 red--text d-flex align-center">
          <v-icon left color="error">mdi-alert-circle-outline</v-icon>
          Λεπτομέρειες Σφάλματος myDATA
        </v-card-title>
        <v-card-text>
          <div class="mb-2">
            <strong>Παραστατικό:</strong> {{ selectedErrorItem.formatted_title }}
          </div>
          <div class="mb-2">
            <strong>Συναλλασσόμενος:</strong> {{ selectedErrorItem.counterpart_name }} (ΑΦΜ: {{ selectedErrorItem.counterpart_afm }})
          </div>
          <div class="mb-2" v-if="selectedErrorItem.last_attempt_at">
            <strong>Τελευταία προσπάθεια:</strong> {{ selectedErrorItem.last_attempt_at }}
          </div>
          <v-divider class="my-3"></v-divider>
          <div class="text-subtitle-2 mb-1">Μήνυμα ΑΑΔΕ / Primer:</div>
          <v-sheet
            color="grey lighten-4"
            class="pa-3 rounded text-body-2 red--text text--darken-3 font-weight-medium"
            style="word-break: break-word;"
          >
            {{ selectedErrorItem.last_error || 'Δεν υπάρχει διαθέσιμο μήνυμα σφάλματος.' }}
          </v-sheet>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="errorDialog = false">ΚΛΕΙΣΙΜΟ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Batch Transmission Progress Dialog -->
    <v-dialog v-model="batchDialog" persistent max-width="450px">
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left color="primary">mdi-cloud-upload-multiple</v-icon>
          Μαζική Διαβίβαση σε εξέλιξη
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="mb-2 text-subtitle-2">
            Επεξεργασία {{ batchCurrentIndex }} από {{ batchTotalItems }} παραστατικά...
          </div>
          <v-progress-linear
            :value="(batchCurrentIndex / Math.max(batchTotalItems, 1)) * 100"
            height="18"
            striped
            color="primary"
            rounded
          >
            <template v-slot:default="{ value }">
              <strong class="white--text text-caption">{{ Math.ceil(value) }}%</strong>
            </template>
          </v-progress-linear>

          <div class="mt-4 text-caption">
            <div><v-icon small color="success">mdi-check</v-icon> Επιτυχίες: {{ batchSuccessCount }}</div>
            <div><v-icon small color="error">mdi-close</v-icon> Αποτυχίες: {{ batchFailCount }}</div>
          </div>
        </v-card-text>
        <v-card-actions v-if="batchFinished">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeBatchDialog">ΟΛΟΚΛΗΡΩΣΗ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "PendingTransmissionsPage",

  data: () => ({
    loading: false,
    provider: "none",
    items: [],

    // Filters
    panelOpen: [0],
    menuDateStart: false,
    menuDateStop: false,
    documentIssueDateStartFilter: null,
    documentIssueDateStopFilter: null,
    documentKindFilter: "all",
    searchQuery: "",

    documentKindOptions: [
      { text: "Όλα τα είδη", value: "all" },
      { text: "Πωλήσεις (Τιμολόγια, Πιστωτικά)", value: "sales" },
      { text: "Υπηρεσίες (ΑΠΥ, Παροχής)", value: "service" },
      { text: "Μεταφορές (Φορτωτικές)", value: "transportation" },
      { text: "Αποθήκη (Δελτία Αποστολής)", value: "warehouse" },
      { text: "Τίτλοι Κτήσης", value: "acquisition" },
    ],

    // Messages
    successMessage: null,
    errorMessage: null,

    // Transmission states
    transmittingKey: null,

    // Error Dialog
    errorDialog: false,
    selectedErrorItem: {},

    // Batch transmission states
    batchDialog: false,
    isBatchTransmitting: false,
    batchFinished: false,
    batchCurrentIndex: 0,
    batchTotalItems: 0,
    batchSuccessCount: 0,
    batchFailCount: 0,

    headers: [
      {
        text: "Ημερομηνία",
        value: "issue_date",
        align: "start",
        width: "110px",
      },
      {
        text: "Είδος",
        value: "document_kind_label",
        align: "center",
        width: "120px",
      },
      {
        text: "Παραστατικό",
        value: "formatted_title",
        align: "start",
        width: "180px",
      },
      {
        text: "Συναλλασσόμενος",
        value: "counterpart_name",
        align: "start",
      },
      {
        text: "Καθαρή Αξία",
        value: "net_value",
        align: "end",
        width: "110px",
      },
      {
        text: "ΦΠΑ",
        value: "tax_value",
        align: "end",
        width: "100px",
      },
      {
        text: "Συνολική Αξία",
        value: "gross_value",
        align: "end",
        width: "120px",
      },
      {
        text: "Κατάσταση",
        value: "status",
        align: "center",
        width: "110px",
        sortable: false,
      },
      {
        text: "Ενέργειες",
        value: "actions",
        align: "center",
        width: "120px",
        sortable: false,
      },
    ],
  }),

  computed: {
    filteredItems() {
      if (this.documentKindFilter === "all") {
        return this.items;
      }
      return this.items.filter(
        (item) => item.document_kind === this.documentKindFilter
      );
    },

    totalGrossSum() {
      if (!this.filteredItems || this.filteredItems.length === 0) return 0;
      return this.filteredItems.reduce(
        (acc, item) => acc + (parseFloat(item.gross_value) || 0),
        0
      );
    },
  },

  created() {
    const initialDaysBefore = 30;
    const today = new Date();
    const filterStart = new Date();
    filterStart.setDate(today.getDate() - initialDaysBefore);

    this.documentIssueDateStartFilter = this.$localDateString
      ? this.$localDateString(filterStart)
      : filterStart.toISOString().split("T")[0];

    this.getData();
  },

  methods: {
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD/MM/YYYY");
    },

    formatCurrency(value) {
      return (
        Number(value || 0).toLocaleString("el-GR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + " €"
      );
    },

    getKindColor(kind) {
      switch (kind) {
        case "sales":
          return "primary";
        case "service":
          return "purple darken-1";
        case "transportation":
          return "teal darken-1";
        case "warehouse":
          return "deep-orange darken-1";
        case "acquisition":
          return "indigo darken-1";
        default:
          return "grey darken-1";
      }
    },

    getKindIcon(kind) {
      switch (kind) {
        case "sales":
          return "mdi-cart-outline";
        case "service":
          return "mdi-briefcase-outline";
        case "transportation":
          return "mdi-truck-outline";
        case "warehouse":
          return "mdi-package-variant-closed";
        default:
          return "mdi-file-outline";
      }
    },

    clearFilters() {
      this.documentIssueDateStartFilter = null;
      this.documentIssueDateStopFilter = null;
      this.documentKindFilter = "all";
      this.searchQuery = "";
      this.getData();
    },

    getData() {
      this.loading = true;
      this.errorMessage = null;

      const params = {};
      if (this.documentIssueDateStartFilter) {
        params.issue_date_start = this.documentIssueDateStartFilter;
      }
      if (this.documentIssueDateStopFilter) {
        params.issue_date_stop = this.documentIssueDateStopFilter;
      }
      if (this.documentKindFilter && this.documentKindFilter !== "all") {
        params.document_kind = this.documentKindFilter;
      }

      axios
        .get("/api/mydata/pending", { params })
        .then((response) => {
          this.provider = response.data.provider || "none";
          this.items = response.data.documents || [];
        })
        .catch((error) => {
          console.error(error);
          this.errorMessage =
            error.response?.data?.message ||
            "Σφάλμα κατά την ανάκτηση των εκκρεμών παραστατικών.";
        })
        .finally(() => {
          this.loading = false;
        });
    },

    transmitSingle(item) {
      const key = `${item.document_kind}-${item.id}`;
      this.transmittingKey = key;
      this.errorMessage = null;

      axios
        .post("/api/mydata/pending/transmit", {
          document_kind: item.document_kind,
          document_id: item.id,
        })
        .then((response) => {
          const mark = response.data.invoice_mark || "";
          const msg =
            response.data.message || `Επιτυχής διαβίβαση! (Mark: ${mark})`;

          if (this.$swal) {
            this.$swal({
              title: "Επιτυχής Διαβίβαση!",
              text: msg,
              icon: "success",
              confirmButtonText: "Εντάξει",
              timer: 3500,
            });
          } else {
            this.successMessage = msg;
          }

          // Remove the successfully transmitted document from the list
          const idx = this.items.findIndex(
            (i) => i.id === item.id && i.document_kind === item.document_kind
          );
          if (idx !== -1) {
            this.items.splice(idx, 1);
          }
        })
        .catch((error) => {
          console.error(error);
          let errText = error.response?.data?.message || "Αποτυχία διαβίβασης του παραστατικού.";
          if (error.response?.data?.errors) {
            errText = Object.values(error.response.data.errors).flat().join(" | ");
          }

          // Update item's last_error so the user can see it inline
          item.last_error = errText;

          if (this.$swal) {
            this.$swal({
              title: "Σφάλμα Διαβίβασης",
              text: errText,
              icon: "error",
              confirmButtonText: "Εντάξει",
            });
          } else {
            this.errorMessage = errText;
          }
        })
        .finally(() => {
          this.transmittingKey = null;
        });
    },

    openErrorDialog(item) {
      this.selectedErrorItem = item;
      this.errorDialog = true;
    },

    async transmitAll() {
      if (this.filteredItems.length === 0) return;

      const result = await (this.$swal
        ? this.$swal({
            title: "Μαζική Διαβίβαση",
            text: `Πρόκειται να διαβιβαστούν ${this.filteredItems.length} παραστατικά. Επιθυμείτε να συνεχίσετε;`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Ναι, έναρξη",
            cancelButtonText: "Άκυρο",
          })
        : Promise.resolve({ isConfirmed: confirm("Έναρξη μαζικής διαβίβασης;") }));

      if (!result.isConfirmed) return;

      this.isBatchTransmitting = true;
      this.batchDialog = true;
      this.batchFinished = false;
      this.batchCurrentIndex = 0;
      this.batchSuccessCount = 0;
      this.batchFailCount = 0;

      const itemsToProcess = [...this.filteredItems];
      this.batchTotalItems = itemsToProcess.length;

      for (let i = 0; i < itemsToProcess.length; i++) {
        const item = itemsToProcess[i];
        this.batchCurrentIndex = i + 1;

        try {
          await axios.post("/api/mydata/pending/transmit", {
            document_kind: item.document_kind,
            document_id: item.id,
          });

          this.batchSuccessCount++;
          // Remove from list
          const idx = this.items.findIndex(
            (it) => it.id === item.id && it.document_kind === item.document_kind
          );
          if (idx !== -1) {
            this.items.splice(idx, 1);
          }
        } catch (err) {
          this.batchFailCount++;
          item.last_error =
            err.response?.data?.message || "Αποτυχία διαβίβασης.";
        }

        // Slight pause between calls to be gentle on external tax APIs
        await new Promise((resolve) => setTimeout(resolve, 300));
      }

      this.batchFinished = true;
    },

    closeBatchDialog() {
      this.batchDialog = false;
      this.isBatchTransmitting = false;
      this.getData();
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1400px;
}
</style>
